






































































































import {Component, Prop, Ref, Vue} from 'vue-property-decorator';
import JdiContent from "@/components/JdiContent.vue"
import JdiDocs from "@/components/JdiDocs.vue"
import JdiPreview from "@/components/JdiPreview.vue"
import JdsCallout from "@/design-system/components/Callout/JdsCallout.vue"

@Component({
    components: {JdsCallout, JdiPreview, JdiDocs, JdiContent}
})
export default class DropdownMenu extends Vue {

}
